import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';


const ModalLogisticCreate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createLogistic');
  const onClose = () => {
    closeSingleModal('createLogistic');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova logística"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Export.Logistic.Create />
    </Modal>
  );
};

export default ModalLogisticCreate;
